"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var enums_1 = require("./enums");
var config_default_1 = require("./config.default");
var appenders_population_1 = require("./tools/appenders.population");
var Timber = /** @class */ (function () {
    function Timber(config) {
        this.config = __assign({}, config_default_1.defaultConfig);
        if (config) {
            this.setConfig(config);
        }
    }
    Timber.prototype.trace = function (message, parameters) {
        if (parameters === void 0) { parameters = {}; }
        this.log(enums_1.LogLevel.Trace, message, parameters);
    };
    Timber.prototype.debug = function (message, parameters) {
        if (parameters === void 0) { parameters = {}; }
        this.log(enums_1.LogLevel.Debug, message, parameters);
    };
    Timber.prototype.info = function (message, parameters) {
        if (parameters === void 0) { parameters = {}; }
        this.log(enums_1.LogLevel.Info, message, parameters);
    };
    Timber.prototype.warn = function (message, parameters) {
        if (parameters === void 0) { parameters = {}; }
        this.log(enums_1.LogLevel.Warn, message, parameters);
    };
    Timber.prototype.error = function (message, parameters) {
        if (parameters === void 0) { parameters = {}; }
        this.log(enums_1.LogLevel.Error, message, parameters);
    };
    Timber.prototype.fatal = function (message, parameters) {
        if (parameters === void 0) { parameters = {}; }
        this.log(enums_1.LogLevel.Fatal, message, parameters);
    };
    Timber.prototype.log = function (logLevel, message, parameters) {
        var _this = this;
        if (this.config.minLogLevel > logLevel) {
            return;
        }
        if (!this.config.appenders || this.config.appenders.length === 0) {
            throw new Error('Please specify at least one appender for logger');
        }
        this.config.appenders.map(function (a) {
            var logMessage = _this.getLogMessage(logLevel, _this.config, message, parameters);
            a.action(logMessage, _this.config);
        });
    };
    Timber.prototype.setConfig = function (config, setConfigOptions) {
        config = __assign(__assign({}, this.config), config);
        if (!setConfigOptions) {
            setConfigOptions = __assign({}, config_default_1.defaultSetConfigOptions);
        }
        this.config = appenders_population_1.populateAppenders(this.config, config, setConfigOptions);
    };
    Timber.prototype.getLogMessage = function (logLevel, config, message, parameters) {
        return {
            date: this.getCurrentDate(),
            level: enums_1.LogLevel[logLevel],
            value: message,
            exception: parameters.error,
            url: window.location.href,
            module: parameters.module || config.module,
            appId: config.appId,
            companyId: config.companyId,
            userId: config.userId
        };
    };
    Timber.prototype.getCurrentDate = function () {
        var date = new Date();
        return {
            localDate: date.toString(),
            utcDate: date.toUTCString(),
        };
    };
    return Timber;
}());
exports.Timber = Timber;
//# sourceMappingURL=index.js.map